export const ACCEPTED_FILE_EXTENSIONS = '.jpeg,.jpg,.png';
export const MAX_FILE_SIZE = 5242880; // 5MB
export const AGENT_BULLETIN_BOARD_STORAGE_PREFIX = 'agent_bulletin_board';
export const THUMBNAIL_LOADING =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8/x8AAuMB8DtXNJsAAAAASUVORK5CYII=';
export const ROW_HEIGHT = 180;
export const DEFAULT_DELAY = 5;
